import React from "react";
import { Link } from "react-router-dom";

const footerItems = [
  { itemName: "Datenschutz & AGBS", link: "/terms" },
  { itemName: "Impressum", link: "/impressum" },
  { itemName: "Kontakt", link: "/contact" },
  { itemName: "Unsere Leistungen", link: "/service" },
];

const FooterList = () => {
  return (
    <ul>
      {footerItems.map((item, i) => (
        <li key={i}>
          <Link to={item.link}>{item.itemName}</Link>
        </li>
      ))}
    </ul>
  );
};

export default FooterList;
